module.exports = __webpack_public_path__ + "static/media/Mopex W.e22542f0.jpg";